/**
 * shared/webauthn-keypair-binding.ts — one-account-per-passkey user copy
 *
 * SINGLE SOURCE OF TRUTH for the two refusals the keypair-binding rule can
 * produce (ledger #90, migration 0137). Lives in shared/ for the same reason
 * `webauthn-device-limits.ts` does: BOTH sides use these strings — the server
 * throws them as `WebAuthnError` messages
 * (server/logic/webauthn/registration-store.ts) and the client renders them
 * (client/src/lib/webauthn-errors/messages.ts). Two hand-kept copies would
 * drift, and the disclosure property below only holds on whichever copy
 * somebody remembers to edit.
 */

/**
 * A keypair already live on an account.
 *
 * NAMES NO ACCOUNT, USERNAME, OR OWNER — and that constraint is the reason
 * this string is centralised. The caller learns only a fact about the
 * authenticator in their own hand, never whether some other person holds an
 * account here (CLAUDE.md §Identifier account limits, no enumeration oracle).
 * It may be specific about the cause precisely because the refused party is
 * physically holding the key; the email/phone refusals may not be.
 *
 * Phrased as a possession fact — it says a key was presented, and nothing
 * about who presented it or whether anyone was present.
 */
export const CREDENTIAL_ALREADY_BOUND_MESSAGE =
  "This passkey is already registered to an account. A passkey can only belong to one account — " +
  "sign in with it, or use a different authenticator to register.";

/**
 * A key whose COSE parameters cannot be canonicalised.
 *
 * Names the remedy, not the internal reason: the user can act on "try another
 * authenticator" and can do nothing with "unsupported COSE key type".
 */
export const CREDENTIAL_KEY_UNSUPPORTED_MESSAGE =
  "This authenticator's key format isn't supported yet. Try a different passkey or security key.";
